import ListGroupController from '../list_group_controller'

export default class extends ListGroupController {

	static targets = [
		'list',
		'item',
		'itemCounter',
		'sessionActivity',
	]

	// This method is easy to override in a subclass for custom html list-group-item elements.
	renderItem(data) {
		const li = document.createElement('li')
		li.classList.add('list-group-item')
		li.setAttribute('data-app--participants-list-target', 'item')
		li.setAttribute('data-id', data.id)
		li.innerHTML =
`<div class="d-flex flex-row justify-content-between align-items-center">
	<input type="hidden" name="session[session_participant][${data.id}][participant_id]" value="${data.id}">
	<div>
		<div>${data.name}</div>
		<div class="display-11 text-600">${data.locationName}</div>
	</div>
	${this.renderActivityCheckboxes(data)}
	<div class="">
		<button type="button" class="btn btn-sm btn-outline-danger" data-action="app--participants-list#removeItem">
			<div class="fa fas fa-times"></div>
			Delete
		</button>
	</div>
</div>`
		return li
	}

	renderActivityCheckboxes(itemData) {
		let checkboxesHTML = ""
		const activities = this.getActivities()
		for (let activity of activities) {
			let shortLabel = activity.name.length > 30 ? activity.name.slice(0, 30) + '...' : activity.name;
			shortLabel = shortLabel = shortLabel.replace(/ /g, "<br>")
			//onclick="this.querySelector(\'input[type=checkbox]\').click()"
			checkboxesHTML +=
`<div class='text-center border rounded p-1'>
	<label for='participant_${itemData.id}_activity_${activity.id}'>
		<div class='display-10'>${shortLabel}</div>
	</label>
	<div>
	<input id='participant_${itemData.id}_activity_${activity.id}' type='checkbox' class='form-check-input' name='session[session_participant][${itemData.id}][activity_id]' value='${activity.id}'></input>
	</div>
</div>`
		}
		return checkboxesHTML
	}

	getActivities() {
		const activities = []
		for (let activity of this.sessionActivityTargets) {
			if (activity.value && activity.innerText) {
				const activityObject = {
					id: activity.value,
					name: activity.innerText
				}

				activities.push(activityObject)
			}
		}

		return activities
	}

}
